const SignalIcon = (props: React.ComponentProps<'svg'>) => {
    return (
        <svg
            {...props}
            xmlns={'http://www.w3.org/2000/svg'}
            width={'24'}
            height={'24'}
            viewBox={'0 0 24 24'}
            fill={'none'}
        >
            <path
                d={
                    // eslint-disable-next-line max-len
                    'M9.348 14.652a3.75 3.75 0 0 1 5.304 0m-7.425-2.121a6.75 6.75 0 0 1 9.546 0m-11.667-2.121a9.75 9.75 0 0 1 13.788 0M12 18.75h.008v.008H12v-.008Z'
                }
                stroke={'currentColor'}
                strokeWidth={'1.5'}
                strokeLinecap={'round'}
                strokeLinejoin={'round'}
            />
        </svg>
    );
};

export default SignalIcon;
